import React from 'react';
import Section from "./Section.js";
import SubSection from "./SubSection.js";
import ListPicker from "./ListPicker";
import { Grid, Typography } from '@material-ui/core';
import MyButton from "./MyButton";
import Actions from "../modules/actions";
import { connect } from "react-redux";
import GeneratePDF from "../modules/GeneratePDF";
import Link from "./Link";
import Rating from "./Rating";

const mapStateToProps = (state, ownProps) => {
  return ({
    buildings: state.buildings || [],
    currentReportBuildingId: state.currentReportBuildingId,
  });
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  setCurrentReportBuilding: id => dispatch(Actions.setCurrentReportBuilding(id)),
});

const Report = props => {
  const Lang = props.lang.Report;
  return (
    <Section id="Report" header={Lang.header}>
      <SubSection>
        <Grid container spacing={2} item xs={12}>
          <Grid item xs={12}>
            <div className="centerItem">
              <MyButton variant="contained" disabled={!props.currentReportBuildingId} onClick={() => GeneratePDF(props.buildings.find(b => b.buildingId === props.currentReportBuildingId), Lang)}>
                {Lang.generate_report}
              </MyButton>
            </div>
            <Typography style={{fontWeight: "bold"}}>
              {Lang.facade_threat_rating_scale}
            </Typography>
            <Typography>
              {Lang.note}
            </Typography>
          </Grid>
          <Rating color="#3a8b68ff" rating={Lang.low_risk} interpretation={Lang.no_action_required}/>
          <Rating color="cornflowerblue" rating={Lang.moderate_risk} interpretation={Lang.action_is_discretionary}/>
          <Rating color="orange" rating={Lang.high_risk} interpretation={Lang.strongly_recommend_action}/>
          <Rating color="red" rating={Lang.lethal} interpretation={Lang.mandatory_action}/>
        </Grid>
          
        <Link url="https://www.siskinds.com/envirolaw/cadillac-fairview-prosecuted-killing-birds-mirrored-buildings/" text={Lang.canadian_law}/>
      
        <Typography>{Lang.preview_report_for_different_building}</Typography>
        <div className = "centerItem">
          <ListPicker header={Lang.building} options={props.buildings.map(b => b.buildingId)} val={props.currentReportBuildingId} setVal={id => props.setCurrentReportBuilding(id)}></ListPicker>
        </div>
        
      </SubSection>
    </Section>
  );
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Report);



// WEBPACK FOOTER //
// ./src/pages/Report.js